var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m19.327 6.812-6.034-.874L10.59.491Q10.361 0 10 0q-.36 0-.589.49L6.707 5.939l-6.034.874Q0 6.92 0 7.362q0 .253.3.576l4.376 4.238-1.034 5.986a2 2 0 0 0-.024.24q0 .251.126.424.126.174.379.174.216 0 .48-.144L10 16.031l5.397 2.825a1 1 0 0 0 .48.144q.241 0 .367-.174a.7.7 0 0 0 .126-.425q0-.154-.012-.24l-1.034-5.985 4.363-4.238Q20 7.626 20 7.363q0-.444-.673-.55"
})));
export default SvgStar;